export default __webpack_public_path__ + "static/media/bg@1x.98c57b10.webp";